import React, { useState, useEffect } from "react";
import grey from "@material-ui/core/colors/grey";
import CustomerName from "../CommonComponents/Customer_name";
import ShipName_imo from "../CommonComponents/ShipName_imo";
import ReportStatus from "../CommonComponents/ReportStatus";
import SampleStatus from "../CommonComponents/SampleStatus";
import FormControlLabel from '@mui/material/FormControlLabel';
import Fade from '@mui/material/Fade';
import HelpIcon from '@material-ui/icons/Help';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from "@material-ui/core/Checkbox";
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
    Button
} from "@material-ui/core";
import {
    withStyles,
    makeStyles,
    createStyles,
    useTheme,
} from "@material-ui/core/styles";
import Switch from '@mui/material/Switch';
import Box from "@material-ui/core/Box";
import clsx from "clsx";
// import FromDateToDate from '../CommonComponents/FromDateToDate';
import Service_type from "../CommonComponents/Service_type";
import Reporttype from "../CommonComponents/Reporttype"
//import Lab_Fqt from "../CommonComponents/lab_Fqt"
import Bunkerport from "../CommonComponents/bunkerport";
//import Fuelsupplier from "../CommonComponents/Fuelsupplier";
import Bunkeredcity from "../CommonComponents/bunkeredcity";
import Fuelgrade from "../CommonComponents/fuelgrade";
import Iso_spec from "../CommonComponents/iso_spec";
import Bargename from "../CommonComponents/bargename";
import FuelOffSpec from "../CommonComponents/OffSpec";
import Samplenumber from "../CommonComponents/Samplenumber"
import EquipName from "../CommonComponents/EquipName"
import EquipMake from "../CommonComponents/EquipMake"
import EquipModel from "../CommonComponents/EquipModel";
import LoBrand from "../CommonComponents/LoBrand";
import LoGrade from "../CommonComponents/LoGrade";
//import Lab_Tot from "../CommonComponents/lab_Tot";
import Manufacturer from "../CommonComponents/Manufacturer";
import DateComponent from "../CommonComponents/DateComponent";
import Fleet from "../CommonComponents/Fleet";
import DWTRangeComponent from "../CommonComponents/DWTRange";
import ShipyardComponent from "../CommonComponents/Shipyard";
import YearBuiltComponent from "../CommonComponents/YearBuilt";
import AssetEquipmentComponent from "../CommonComponents/AssetsEqupiment";
import Grid from '@mui/material/Grid';
import SerialNumber from "../CommonComponents/SerialNumber";
import Location from "../CommonComponents/Location";
import Voltage from "../CommonComponents/Voltage"
import ClientContract from "../CommonComponents/ClientContract";
import TypeofShip from "../CommonComponents/Typeofship"
import Rating from "../CommonComponents/Rating"
import TotReportDateComponent from "../CommonComponents/TotReportDate"
import TotSampleDateComponent from "../CommonComponents/TotSampleDate"
import LubeReportDateComponent from "../CommonComponents/LubeReportDate";
import FqtReportDateComponent from "../CommonComponents/FqtReportDate";
import LubeSampleDateComponent from "../CommonComponents/LubeSampleDate";
import FqtBunkerDateComponent from "../CommonComponents/FqtBunkerDate";
import FuelSampleDateComponent from "../CommonComponents/FqtSampledate"
import TotSample_number from "../CommonComponents/TotsampleNamber";
import TransformerName from "../CommonComponents/TotTransformername";
import TotSamplestatus from "../CommonComponents/TotSampleStatus"
import LubeSampleStatus from "../CommonComponents/LubeSampleStatus";
import TotUnitDescripitionComponent from "../CommonComponents/TotUnitDescription";
import TotSubCustomerNameComponent from "../CommonComponents/TotSubCustomerName";
import { FilterComponentObj } from "./FilterComponentObj";
import Lab_Fqt from "../CommonComponents/lab_Fqt"
import Lab_Tot from "../CommonComponents/lab_Tot";
import Lab_Lube from "../CommonComponents/lab_Lube";
import FuelShipType from "../CommonComponents/FuelShipType";
import LubeShipType from "../CommonComponents/LubeShipType";
import Fuelsupplier from "../CommonComponents/Fuelsupplier";
import { getCookie } from "../../services/Cookies";
const useStyles = makeStyles((theme) => ({
    justifyContentBetween: {
        justifyContent: "space-between!important",
    },
    alignItemsStretch: {
        alignItems: "stretch",
    },
    borderRight: {
        borderRight: "1px solid " + grey[400],
    },
    MuiButtonBaseRoot: {
        borderRadius: 4,
        padding: 0,
        paddingBottom: "2px",
        color: grey[400],
    },
    MuiSvgIconRoot: {
        color: "#ff4717",
        border: "2px solid " + grey[400],
        fontSize: "1.3rem",
        borderRadius: 3,
    },
    anchorTag: {
        textDecoration: "none",
        cursor: "pointer",
    },
    btnStyle2: {
        borderRadius: "8px",
        border: "2px solid #ff4717",
        boxShadow: "2px 2px 4px 2px #dadada",
        color: "#ffffff",
        background: "#ff4717 !important",
        textTransform: "capitalize",
        padding: "4px 22px",
        marginRight: "8px"
    },
    DisableStyle2: {
        borderRadius: "8px",
        border: "2px solid #ff4717",
        boxShadow: "2px 2px 4px 2px #dadada",
        color: "#ffffff",
        //background: "#ff4717 !important",
        textTransform: "capitalize",
        padding: "4px 22px",
        marginRight: "8px",
        pointerEvents: 'none',
        background: "#dddddd"
    },
    dateLabel: {
        fontFamily: "Roboto,Helvetica,Arial,sans-serif !important",
        fontSize: "0.9rem !important",
        fontWeight: 400,
        marginRight: "143px",
    }
}));
const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const BootstrapDate = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "100%",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);


function FilterComponents(props) {
    
    const classes = useStyles();
    const [formObj, setFormObj] = React.useState(FilterComponentObj);
    const [reset, setReset] = React.useState(0);
    const [defaultValueCheck, setdefaultValueCheck] = React.useState('')
    const [checked, setChecked] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');
    const [isFilterDisabled, setisFilterDisabled] = React.useState(props.isFilterDisabled);
    const [checkedHistory, setCheckedHistory] = React.useState(getCookie('historicvessels'));
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const filtervalue = props.filtervalue;
    const applyFilter = props.applyFilter;
    const UpdateChart = props.UpdateChart;
    const defaultFirstValue = props.defaultFirstValue;
    // const defaultTOTFirstValue = props.defaultTOTFirstValue
    const screen = props.screen;
    const [defaultShipIMO, setDefaultShipIMO] = React.useState({});
    const handleCheckedChange = () => {
        setChecked((prev) => !prev);
    };
const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
};

const handleClose = () => {
    setOpen(false);
};
const descriptionElementRef = React.useRef(null);
React.useEffect(() => {
    if (open) {
        const { current: descriptionElement } = descriptionElementRef;
        if (descriptionElement !== null) {
            descriptionElement.focus();
        }
    }
}, [open]);
const CustomeronChangechild = (newValue) => {
    //

    setFormObj({ ...formObj, customerNameKey: newValue })
    setReset(0);
}
const ShiponChangechild = (newValue) => {
    
    setFormObj({ ...formObj, shipNameImokey: newValue })
    setReset(0);
}
const servicetypechild = (newValue) => {
    setFormObj({ ...formObj, servicetype: newValue })
    setReset(0);
}
const LubeEquipnameonChangechild = (newValue) => {
    //
    setFormObj({ ...formObj, lubeequipname: newValue })
    setReset(0);
}
const LubemakeonChangechild = (newValue) => {
    //
    setFormObj({ ...formObj, lubeequipmake: newValue })
    setReset(0);
}

const LoBrandonChangechild = (newValue) => {
    //
    setFormObj({ ...formObj, lobrand: newValue })
    setReset(0);
}
const LoGradeonChangechild = (newValue) => {
    //
    setFormObj({ ...formObj, lograde: newValue })
    setReset(0);
}

const LubemodelonChangechild = (newValue) => {

    setFormObj({ ...formObj, lubeequipmodel: newValue })
    setReset(0);
}
const BunkerportonChangechild = (newValue) => {

    setFormObj({ ...formObj, Fqtbunkerport: newValue });
    setReset(0);
}

const SampleNumberonChangechild = (newValue) => {
    //props.SamplenumberChange(newValue);
    setFormObj({ ...formObj, Fqtsamplenumber: newValue })
    setReset(0);
}
const TotSampleNumberonChangechild = (newValue) => {
    setFormObj({ ...formObj, Totsamplenumber: newValue })
    setReset(0);
}
const TotSampleStatusonChangechild = (newValue) => {
    setFormObj({ ...formObj, Totsamplestatus: newValue })
    setReset(0);
}
const LubeSampleStatusonChangechild = (newValue) => {
    setFormObj({ ...formObj, lubesamplestatus: newValue })
    setReset(0);
}
const SampleStatusonChangechild = (newValue) => {
    setFormObj({ ...formObj, Fqtsamplestatus: newValue })
    setReset(0);
}

const BargeNameonChangechild = (newValue) => {
    //props.BargeNameChange(newValue);
    setFormObj({ ...formObj, Fqtbargename: newValue })
    setReset(0);
}
const SerialNumberonChangechild = (newValue) => {
    //
    //props.serialNumberChange(newValue);
    setFormObj({ ...formObj, Totserialnumber: newValue })
    setReset(0);
}
const ClientContractonChangechild = (newValue) => {
    props.clientContractChange(newValue);
    //setFormObj({...formObj, customerNameKey: newValue})
    setReset(0);
}
const LocationonChangechild = (newValue) => {
    //props.locationChange(newValue);
    setFormObj({ ...formObj, Totlocation: newValue })
    setReset(0);
}
const VoltageonChangechild = (newValue) => {
    setFormObj({ ...formObj, Totvoltage: newValue })
    setReset(0);
}
const Ratingchild = (newValue) => {

    setFormObj({ ...formObj, TotRating: newValue })
    setReset(0);
}
const FuelOffSpecchild = (newValue) => {
    setFormObj({ ...formObj, FqtOffSpec: newValue })
}
const TotUnitDescripitionchild = (newValue) => {
    setFormObj({ ...formObj, TotUnitDescription: newValue })
    setReset(0);
}
const TotSubCustomerNamechild = (newValue) => {
    setFormObj({ ...formObj, TotSubCustomerName: newValue })
    setReset(0);
}
const LubeReportDateChangechild = (newValue) => {
    //props.LubeReportDatenameChange(newValue);
    setFormObj({ ...formObj, lubereportstartdate: newValue, lubereportenddate: newValue })
    setisFilterDisabled(false);
}
const FuelReportDateChangechild = (newValue) => {
    //props.FuelReportDatenameChange(newValue);
    //
    setFormObj({ ...formObj, Fqtreportstartdate: newValue, Fqtreportenddate: newValue })
    setisFilterDisabled(false);
}
const TotReportDateChangechild = (newValue) => {
    //props.TotReportDatenameparent(newValue);
    setFormObj({ ...formObj, Totreportstartdate: newValue, Totreportenddate: newValue })
}
const TotSampledDateChangechild = (newValue) => {
    //props.TotSampledDatenameChange(newValue);
    setFormObj({ ...formObj, Totsamplestartdate: newValue, Totsampleenddate: newValue })
    setisFilterDisabled(false);
    setReset(0);
}
const FqtBunkerDateChange = (newValue) => {
    setFormObj({ ...formObj, Fqtbunkerstartdate: newValue, Fqtbunkerenddate: newValue })
    setReset(0);
}
const LubeSampledDateChangechild = (newValue) => {
    //props.LubeSampledDatenameChange(newValue);
    setFormObj({ ...formObj, lubesamplestartdate: newValue, lubesampleenddate: newValue })
}
const FuelSampledDateChangechild = (newValue) => {
    //
    //props.FuelSampledDatenameChange(newValue);
    setFormObj({ ...formObj, Fqtsamplestartdate: newValue, Fqtsampleenddate: newValue })
    setReset(0);
}
const TransformerNamechange = (newValue) => {
    
    setFormObj({ ...formObj, TotTransformerName: newValue })
    setReset(0);
}
const manufactureChild = (newValue) => {
    //
    setFormObj({ ...formObj, Totmanufacture: newValue })
    setReset(0);
}
const FqtLab = (newValue) => {
    setFormObj({ ...formObj, Fqtlab: newValue })
    setReset(0);
}
const Fuelsupplierchange = (newValue) => {
    setFormObj({ ...formObj, FqtSupplier: newValue })
    setReset(0);
}
const LubeLab = (newValue) => {
    setFormObj({ ...formObj, lubelab: newValue })
    setReset(0);
}
const TotLab = (newValue) => {
    setFormObj({ ...formObj, Totlab: newValue })
    setReset(0);
}
const Fuelshiptypechange = (newValue) => {
    setFormObj({ ...formObj, FqtShipType: newValue })
    setReset(0);
}
const Lubeshiptypechange = (newValue) => {
    setFormObj({ ...formObj, lubeShipType: newValue })
    setReset(0);
}

const fuelgradeonChangechild = (newValue) => {
    setFormObj({ ...formObj, Fqtfuelgrade: newValue })
    setReset(0);
}
const handleChange = (event) => {
    
    setCheckedHistory(event.target.checked);
    setFormObj({ ...formObj, HistoricVessel: event.target.checked })

};
const onClickApplyFilter = () => {
   debugger
    applyFilter(formObj);
}
const onClickUpdateChart = () => {


    UpdateChart(formObj);
}
const onClear = () => {
    debugger
    setReset(reset + 1);
    setCheckedHistory(getCookie('historicvessels'));
  
     localStorage.removeItem('FilterSetting');
    localStorage.removeItem('TOTFilterSetting');
    if (props.reset) {
        props.reset(defaultValue(GlobalFilterSettingValue));
    }
   


}
const isFilterDisabledClear = (value) => {
   
    //isFilterDisabled = value;
    setisFilterDisabled(value);
}

useEffect(() => {

    defaultValue(GlobalFilterSettingValue);
   
}, []);

const defaultValue = (val) => {
    debugger
    let Obj = {};
    if (val !== "" && val !== undefined && val !== "null") {
        Obj = JSON.parse(val);
        console.log('getcookievalue', formObj)
    }
    if (props.defaultDate) {
        filtervalue.map(function (item, i) {
            if (item.includes("TotReportDateComponent")) {
                Obj.Totreportstartdate = [(props.defaultDate && props.defaultDate.startDate ? props.defaultDate.startDate : null)];
                Obj.Totreportenddate = [(props.defaultDate && props.defaultDate.endDate ? props.defaultDate.endDate : null)];
            }
            if (item.includes("TotSampleDateComponent")) {
                Obj.Totsamplestartdate = [(props.defaultDate && props.defaultDate.startDate ? props.defaultDate.startDate : null)];
                Obj.Totsampleenddate = [(props.defaultDate && props.defaultDate.endDate ? props.defaultDate.endDate : null)];
            }
            if (item.includes("LubeReportDateComponent")) {
                Obj.lubereportstartdate = [(props.defaultDate && props.defaultDate.startDate ? props.defaultDate.startDate : null)];
                Obj.lubereportenddate = [(props.defaultDate && props.defaultDate.endDate ? props.defaultDate.endDate : null)];
            }
            if (item.includes("FqtReportDateComponent")) {
                Obj.Fqtreportstartdate = [(props.defaultDate && props.defaultDate.startDate ? props.defaultDate.startDate : null)];
                Obj.Fqtreportenddate = [(props.defaultDate && props.defaultDate.endDate ? props.defaultDate.endDate : null)];
            }
            if (item.includes("LubeSampleDateComponent")) {
                Obj.lubesamplestartdate = [(props.defaultDate && props.defaultDate.startDate ? props.defaultDate.startDate : null)];
                Obj.lubesampleenddate = [(props.defaultDate && props.defaultDate.endDate ? props.defaultDate.endDate : null)];
            }
            if (item.includes("FuelSampleDateComponent")) {
                Obj.Fqtsamplestartdate = [(props.defaultDate && props.defaultDate.startDate ? props.defaultDate.startDate : null)];
                Obj.Fqtsampleenddate = [(props.defaultDate && props.defaultDate.endDate ? props.defaultDate.endDate : null)];
            }



        });

    }
    if (getCookie('historicvessels') === 'true') {
        Obj = { ...Obj, HistoricVessel: true}
       
      } else {
        Obj = { ...Obj, HistoricVessel: false }
       
       }
    if (screen == 'reportsToT' || screen == 'assetsToT' || screen == 'trendsToT' || screen == 'schedulerToT' || screen == 'samplesToT') {
        if (localStorage.getItem('TOTFilterSetting') !== "" && localStorage.getItem('TOTFilterSetting') !== undefined && localStorage.getItem('TOTFilterSetting') !== null && localStorage.getItem('TOTFilterSetting') !== "null") {
            Obj = Object.assign(Obj, JSON.parse(localStorage.getItem("TOTFilterSetting")))
        }
    }
    else {
        if (localStorage.getItem('FilterSetting') !== "" && localStorage.getItem('FilterSetting') !== undefined && localStorage.getItem('FilterSetting') !== null && localStorage.getItem('FilterSetting') !== "null") {
            Obj = Object.assign(Obj, JSON.parse(localStorage.getItem("FilterSetting")))
        }
    }
    setFormObj(Obj);
    return Obj;
}
// const getupdatechartbutton = () => {
//     return
// }
// const buttondisable = () => {

//     if (UpdateChart !== undefined && formObj?.Totsamplestartdate != null && formObj?.Totsampleenddate != null) {
//         return false
//     } else if (UpdateChart !== undefined && formObj?.Fqtreportstartdate != null && formObj?.Fqtreportenddate != null) {
//         return false
//     } else if (UpdateChart !== undefined && formObj?.lubereportstartdate != null && formObj?.lubereportenddate != null) {
//         return false
//     } else {
//         return true
//     }
// }

// const toolTipValue = () => {
//     //
//     if (UpdateChart !== undefined && formObj?.Totsamplestartdate != null && formObj?.Totsampleenddate != null) {
//         return ""
//     } else if (UpdateChart !== undefined && formObj?.Fqtreportstartdate != null && formObj?.Fqtreportenddate != null) {
//         return ""
//     } else if (UpdateChart !== undefined && formObj?.lubereportstartdate != null && formObj?.lubereportenddate != null) {
//         return ""
//     } else {
//         return "Please Select Date"
//     }
// }


useEffect(() => {
  
    if (defaultValueCheck === 'defaultValue' && props.defaultFirstValue[0] === "ShipName_imo" && formObj.shipNameImokey !== '' && formObj.shipNameImokey !== undefined) {
        onClickApplyFilter();
    } else if (defaultValueCheck === 'defaultValue' && props.defaultFirstValue[0] === "TransformerName" && formObj.TotTransformerName !== '' && formObj.TotTransformerName !== undefined) {
        onClickApplyFilter();
    }


}, [formObj]);
   

const getCommonCmp = (item, i) => {
    let isDate = item.includes("DateComponent") ? true : false;
    let gridProps = {
        xs: 6,
        md: 4
    }
    if (isDate) {
        gridProps.xs = 12;
        gridProps.md = 4;
        gridProps.sm = 6;
        gridProps.className = "doubledate"
    }
    return <Grid item {...gridProps} >
        {item.includes("CustomerName") ? <CustomerName screen={screen} onChange={CustomeronChangechild} reset={reset} /> : null}
        {item.includes("ShipName_imo") ? <ShipName_imo onChange={ShiponChangechild} reset={reset} HistoricVessel={checkedHistory} /> : null}
        {item.includes("Location") ? <Location onChange={LocationonChangechild} reset={reset} /> : null}
        {item.includes("Service_type") ? <Service_type onChange={servicetypechild} reset={reset} /> : null}
        {item.includes("LoBrand") ? <LoBrand onChange={LoBrandonChangechild} reset={reset} /> : null}
        {item.includes("LoGrade") ? <LoGrade onChange={LoGradeonChangechild} reset={reset} /> : null}
        {item.includes("EquipName") ? <EquipName onChange={LubeEquipnameonChangechild} reset={reset} /> : null}
        {item.includes("EquipMake") ? <EquipMake onChange={LubemakeonChangechild} reset={reset} /> : null}
        {item.includes("EquipModel") ? <EquipModel onChange={LubemodelonChangechild} reset={reset} /> : null}
        {item.includes("Reporttype") ? <Reporttype reset={reset} /> : null}
        {item.includes("Bunkerport") ? <Bunkerport onChange={BunkerportonChangechild} reset={reset} /> : null}
        {item.includes("Fuelgrade") ? <Fuelgrade onChange={fuelgradeonChangechild} reset={reset} /> : null}
        {item.includes("Iso_spec") ? <Iso_spec reset={reset} /> : null}
        {item.includes("Bargename") ? <Bargename onChange={BargeNameonChangechild} reset={reset} /> : null}
        {item.includes("Samplenumber") ? <Samplenumber onChange={SampleNumberonChangechild} reset={reset} /> : null}
        {item.includes("TotSample_number") ? <TotSample_number onChange={TotSampleNumberonChangechild} reset={reset} /> : null}
        {item.includes("TotSamplestatus") ? <TotSamplestatus onChange={TotSampleStatusonChangechild} reset={reset} /> : null}
        {item.includes("LubeSampleStatus") ? <LubeSampleStatus onChange={LubeSampleStatusonChangechild} reset={reset} /> : null}
        {item.includes("SampleStatus") ? <SampleStatus onChange={SampleStatusonChangechild} reset={reset} /> : null}
        {item.includes("ClientContract") ? <ClientContract onChange={ClientContractonChangechild} reset={reset} /> : null}
        {item.includes("SerialNumber") ? <SerialNumber onChange={SerialNumberonChangechild} reset={reset} /> : null}
        {item.includes("Voltage") ? <Voltage onChange={VoltageonChangechild} reset={reset} /> : null}
        {item.includes("Fleet") ? <Fleet reset={reset} /> : null}
        {item.includes("DWTRangeComponent") ? <DWTRangeComponent reset={reset} /> : null}
        {item.includes("TypeofShip") ? <TypeofShip reset={reset} /> : null}
        {item.includes("Rating") ? <Rating onChange={Ratingchild} reset={reset} /> : null}
        {item.includes("FuelOffSpec") ? <FuelOffSpec onChange={FuelOffSpecchild} reset={reset} /> : null}
        {item.includes("TotUnitDescripitionComponent") ? <TotUnitDescripitionComponent onChange={TotUnitDescripitionchild} reset={reset} /> : null}
        {item.includes("TotSubCustomer_NameComponent") ? <TotSubCustomerNameComponent onChange={TotSubCustomerNamechild} reset={reset} /> : null}
        {item.includes("Manufacturer") ? <Manufacturer onChange={manufactureChild} reset={reset} /> : null}
        {item.includes("TotReportDateComponent") ? <><Box component="label" className={classes.dateLabel}> Reported Date (From - To)</Box><TotReportDateComponent onChange={TotReportDateChangechild} reset={reset} Totreportstartdate={props.defaultDate && props.defaultDate.startDate ? props.defaultDate.startDate : null} Totreportenddate={props.defaultDate && props.defaultDate.endDate ? props.defaultDate.endDate : null} /></> : null}
        {item.includes("TotSampleDateComponent") ? <><Box component="label" className={classes.dateLabel}> Sampled Date (From - To)</Box><TotSampleDateComponent isFilterDisabledClear={isFilterDisabledClear} onChange={TotSampledDateChangechild} reset={reset} Totsamplestartdate={props.defaultDate && props.defaultDate.startDate ? props.defaultDate.startDate : null} Totsampleenddate={props.defaultDate && props.defaultDate.endDate ? props.defaultDate.endDate : null} /></> : null}
        {item.includes("LubeReportDateComponent") ? <><Box component="label" className={classes.dateLabel}> Reported Date (From - To)</Box><LubeReportDateComponent isFilterDisabledClear={isFilterDisabledClear} onChange={LubeReportDateChangechild} reset={reset} lubereportstartdate={props.defaultDate && props.defaultDate.startDate ? props.defaultDate.startDate : null} lubereportenddate={props.defaultDate && props.defaultDate.endDate ? props.defaultDate.endDate : null} /></> : null}
        {item.includes("FqtReportDateComponent") ? <><Box component="label" className={classes.dateLabel}> Reported Date (From - To)</Box><FqtReportDateComponent isFilterDisabledClear={isFilterDisabledClear} onChange={FuelReportDateChangechild} reset={reset} Fqtreportstartdate={props.defaultDate && props.defaultDate.startDate ? props.defaultDate.startDate : null} Fqtreportenddate={props.defaultDate && props.defaultDate.endDate ? props.defaultDate.endDate : null} /> </> : null}
        {item.includes("LubeSampleDateComponent") ? <><Box component="label" className={classes.dateLabel}> Sampled Date (From - To)</Box><LubeSampleDateComponent onChange={LubeSampledDateChangechild} reset={reset} lubesamplestartdate={props.defaultDate && props.defaultDate.startDate ? props.defaultDate.startDate : null} lubesampleenddate={props.defaultDate && props.defaultDate.endDate ? props.defaultDate.endDate : null} /> </> : null}
        {item.includes("FuelSampleDateComponent") ? <><Box component="label" className={classes.dateLabel}> Sampled Date (From - To)</Box><FuelSampleDateComponent onChange={FuelSampledDateChangechild} reset={reset} Fqtsamplestartdate={props.defaultDate && props.defaultDate.startDate ? props.defaultDate.startDate : null} Fqtsampleenddate={props.defaultDate && props.defaultDate.endDate ? props.defaultDate.endDate : null} /></> : null}
        {item.includes("FqtBunkerDateComponent") ? <><Box component="label" className={classes.dateLabel}> Bunkered Date (From - To)</Box><FqtBunkerDateComponent onChange={FqtBunkerDateChange} reset={reset} /> </> : null}
        {item.includes("TransformerName") ? <TransformerName onChange={TransformerNamechange} reset={reset} /> : null}
        {item.includes("Lab_Fqt") ? <Lab_Fqt onChange={FqtLab} reset={reset} /> : null}
        {item.includes("Fuelsupplier") ? <Fuelsupplier onChange={Fuelsupplierchange} reset={reset} /> : null}
        {item.includes("Lab_Lube") ? <Lab_Lube onChange={LubeLab} reset={reset} /> : null}
        {item.includes("Lab_Tot") ? <Lab_Tot onChange={TotLab} reset={reset} /> : null}
        {item.includes("FuelShipType") ? <FuelShipType onChange={Fuelshiptypechange} reset={reset} /> : null}
        {item.includes("LubeShipType") ? <LubeShipType onChange={Lubeshiptypechange} reset={reset} /> : null}

    </Grid>;
}

const getFilters = () => {
    return <><Grid container spacing={2} style={{ padding: 5 }}>
        {filtervalue.map(function (item, i) {
            return getCommonCmp(item, i);
        })
        }
    </Grid>
        <Grid container spacing={3}>
            <Grid item xs={8}>
                <Box component="div" display="flex" py={1} pl={1} justifyContent="left"   >
                    {screen == "trends" || screen =="trendsToT" ?
                        <Button variant="outlined" onClick={onClickApplyFilter} className={classes.btnStyle2} disabled={isFilterDisabled}>
                            Apply Filters
                        </Button>
                        :
                        <Button variant="outlined" onClick={onClickApplyFilter} className={classes.btnStyle2}>
                            Apply Filters
                        </Button>}

                    {/* {getupdatechartbutton()}  */}
                    <Button variant="outlined" onClick={onClear} className={classes.btnStyle2} >
                        Reset
                    </Button>
                </Box>
            </Grid>
            <Grid item xs={4} style={{ textAlign: "right" }} >
                <div className="subtitle1" onClick={handleClickOpen('paper')} style={{ cursor: "pointer", textDecoration: "underline" }}>Tips & Tricks</div>
            </Grid>
        </Grid>

    </>
}
return (
    <div>
        <Box component="div" className="pos_relative">
            <Box component="div" className="help_blk2">
                <Button onClick={handleClickOpen('paper')}> <HelpIcon style={{ color: "#ff4717" }} /></Button>

                <Dialog
                    open={open}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">Tips & Tricks</DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            tabIndex={-1}
                        >

                            <p className="subtitle">Filters panel help section</p><br />
                            <ul>
                                <li>Type some thing in auto select box to see options.</li>
                                <li>For multiple selection hold control + click.</li>
                                <li>X button clear all results.</li>
                                <li>Click on close button in individual selection to remove it.</li>
                                <li>Click on Apply Filters to apply selected filters.</li>
                                <li>Click on reset to put the filters back to selection that was made in global filter page.</li>
                            </ul>

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Close</Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Box>
        <Box
            component="div"
            px={1}
            pt={1.2}
            pb={1}
            display="flex"
            className={clsx(
                classes.justifyContentBetween,
                classes.alignItemsStretch
            )}
        >
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} >
                    <Box component="h4" m={0} textAlign="left" className="blcopy" fontWeight="500" >
                        Filters:
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} style={{ marginLeft: "auto" }}>
                    <Box display="flex" justifyContent="flex-end">
                        <FormControlLabel
                            control={<Switch checked={checked} onChange={handleCheckedChange} />}
                            label="Show Filters"
                        />
                    </Box>
                    {screen == 'reports' || screen == 'trends' || screen == 'scheduler' || screen == 'samples' ?
                        <Box display="flex" justifyContent="flex-end">
                            {/* <FormControlLabel
                                control={<Switch checked={checked} onChange={handleCheckedChange} />}
                                label="Show Filters"
                            /> */}
                            <FormControlLabel label="Historic Vessels"
                                control={
                                    <Checkbox checked={checkedHistory} onChange={handleChange} />
                                }
                            />

                        </Box>
                        : ""}
                    {screen == 'reportsToT' || screen == 'trendsToT' || screen == 'schedulerToT' || screen == 'samplesToT' ?
                        <Box display="flex" justifyContent="flex-end">
                            {/* <FormControlLabel
                                control={<Switch checked={checked} onChange={handleCheckedChange} />}
                                label="Show Filters"
                            /> */}
                            <FormControlLabel label="Historic Transformers"
                                control={
                                    <Checkbox checked={checkedHistory} onChange={handleChange} />
                                }
                            />

                        </Box>
                        : ""}
                </Grid>

            </Grid>
        </Box>
        {checked ? getFilters() : null}

    </div>
);

}


// {UpdateChart !== undefined ?
//     <Tooltip title={toolTipValue()}>
//         <div>
//            <Button variant="outlined" disabled={buttondisable()} className={classes.btnStyle2}/*className={buttondisable() != true ? classes.btnStyle2 : classes.DisableStyle2}*/
//                 onClick={onClickUpdateChart}>
//                 Update Chart
//             </Button>
//         </div>
//     </Tooltip>
//     : ""}
export default FilterComponents;